<template>
  <div class="note_card" :style="cardStyle" @click="$emit('click', item)">
    <div v-if="item.title" class="note_title">{{ item.title }}</div>
    <div v-if="item.content" class="note_content">{{ item.content }}</div>
    <div class="note_info">
      <div class="book_info">
        <span v-if="item.bookName" class="book_name">《{{ item.bookName }}》</span>
        <span v-if="item.bookAuthor" class="book_author">{{ item.bookAuthor }}</span>
      </div>
      <div class="note_date">{{ editDate }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'noteCard',
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    editDate() {
      return this.item.editTime ? this.item.editTime.split(' ')[0] : ''
    },
    cardStyle() {
      const colors = [
        'rgba(255, 243, 205, 0.85)',
        'rgba(255, 218, 218, 0.85)',
        'rgba(210, 230, 255, 0.85)',
        'rgba(210, 255, 220, 0.85)',
        'rgba(240, 215, 255, 0.85)',
        'rgba(255, 235, 210, 0.85)'
      ]
      const colorIndex = this.item.id ? this.item.id % colors.length : Math.floor(Math.random() * colors.length)
      const rotate = (Math.random() - 0.5) * 6
      return {
        background: colors[colorIndex],
        transform: `rotate(${rotate}deg)`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.note_card {
  padding: .15rem .18rem;
  border-radius: .04rem;
  cursor: pointer;
  box-shadow: 2px 3px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  break-inside: avoid;
  margin-bottom: .15rem;

  &:hover {
    transform: rotate(0deg) scale(1.03) !important;
    box-shadow: 4px 6px 16px rgba(0, 0, 0, 0.18);
    z-index: 2;
  }

  .note_title {
    font-size: .16rem;
    font-weight: 600;
    color: #333;
    margin-bottom: .06rem;
    word-break: break-all;
  }

  .note_content {
    font-size: .15rem;
    line-height: 1.7;
    color: #333;
    margin-bottom: .1rem;
    word-break: break-all;
    white-space: pre-wrap;
  }

  .note_info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: .12rem;
    color: #888;
    border-top: 1px dashed rgba(0, 0, 0, 0.1);
    padding-top: .08rem;

    .book_info {
      .book_name {
        color: #666;
        font-weight: 500;
      }

      .book_author {
        margin-left: .05rem;
        color: #999;
      }
    }

    .note_date {
      color: #aaa;
      white-space: nowrap;
    }
  }
}
</style>